module.exports = __webpack_public_path__ + "img/9788974839321.dce5f0a2.jpg";